(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxPrintersGoActions(
    $timeout, $filter, toastr, $http,  GoProfilePaging, GoProfileService, $q, $interval,
    GoProfileModel, EventServiceEvents, OnDeviceConfigModel, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        resource: '=resource',
        meta: '=meta',
        callback: '&callback',
      },
      templateUrl: 'app/components/printerList/printersGoActions/printersGoActions.template.html',
      link: function(scope) {

        scope.goVendors = scope.resource.enums.OndeviceSupportedVendor.map(vendor => vendor.name);
        scope.allVendors = scope.resource.enums.Vendor.map(vendor => vendor.name);
        scope.printers = {
          all: scope.context,
          goSupport: [],
          noGoSupport: [],
          processed: {
            installed: [],
            failed: [],
          },
          goVendorPrinters: {}, 
          noGoVendorPrinters: {},
          latestVersion: {
            go: {},
            capture: {}
          }, 
          hasProblems: false,
          missingInstallData: true 
        };


        scope.checkPrinters = function() { 
          angular.forEach(scope.printers.goVendorPrinters, (goVendor) => {
            angular.forEach(goVendor, (printer) => {
              printer.info.problems = definePrinterProblems(printer)
              printer.info.install  = setGoSpecifics(printer);
            })
          })
        }


        scope.updatingGoSoftware = false;
        scope.showNoGoPrinters = false;
        scope.listType = null;
        scope.goVendor = null;

        scope.selectSignInProfile = false;
        scope.selectGoConfig = false;
        scope.vendorPrinters = null;
        scope.singlePrinter = null;
        scope.vendor = null;
        scope.editMode = '';
        scope.installInProgress = false;
        scope.installRetry = false;
        scope.installCompleted = false;
        scope.processDone = false;
        

        // RICOH REQUIRES WINDOWS MACHINE
        function DeviceInstall (printer) {
          this.goConfig = null;
          this.signInProfile = null;
          this.state = {
            ABORT: false,
            IN_PROGRESS: false,
          };
          this.progression = '';
          this.printer = angular.copy(printer);

          this.resetProcess = () => {
            this.progression = '';
            this.state = {ABORT: false, IN_PROGRESS: false};
          }

          this.stopProcess = () => {
            this.state = {ABORT: false, IN_PROGRESS: false};
          }

          this.startInstallationSequence = () => {
            const that = this;
            const deferred = $q.defer()
            this.state.IN_PROGRESS = true;
            this.assignSignInProfile().then(function(response) {
              deferred.resolve(that)
            }).catch(function(error) {
              that.state.ABORT = true;
              that.state.IN_PROGRESS = false;
              deferred.reject(that)
            });
            return deferred.promise
          }

          this.assignSignInProfile = () => {
            const that = this;
            const deferred = $q.defer()
            this.progression = 'ASSIGNING_CREDENTIAL';
            this.printer.assignPrinterCredential(this.signInProfile.info._links.self.href).then(function(response) {
              deferred.resolve(that.assignGoConfiguration());
            }).catch(function(error) {
              that.state.ABORT = true;
              that.state.IN_PROGRESS = false;
              deferred.reject(that);
            });
            return deferred.promise;
          }

          this.assignGoConfiguration = () => {
            const that = this;
            const deferred = $q.defer()
            this.progression = 'ASSIGNING_CONFIG';
            this.printer.assignOnDeviceConfig(this.goConfig.info._links.self.href).then(function(response) {
              deferred.resolve(that.verifySignInProfile());
            }).catch(function(error) {
              that.state.ABORT = true;
              that.state.IN_PROGRESS = false;
              deferred.reject(that);
            });
            return deferred.promise;
          }

          this.verifySignInProfile = () => {
            const that = this;
            const deferred = $q.defer()
            this.progression = 'VERIFYING_CREDENTIAL';
            this.signInProfile.testPrinter(this.printer).then(function(response) {
              deferred.resolve(that.install());
            }).catch(function(error) {
              that.progression = 'PRINTER_CREDENTIAL_VERIFICATION_FAILED';
              that.state.ABORT = true;
              that.state.IN_PROGRESS = false;
              deferred.reject(that);
            });
            return deferred.promise;
          }

          this.install = () => {
            const that = this;
            const deferred = $q.defer()
            this.progression = 'INSTALLING';
            deferred.resolve(this);

            this.printer.deviceInstall().then(function(response) {
            }).catch(function(error) {
              that.progression = 'FAILED';
              that.state.ABORT = true;
              that.state.IN_PROGRESS = false;
            });
            return deferred.promise;
          }

          this.update = () => {
            const that = this;
            const deferred = $q.defer()
            this.progression = 'UPDATING';
            this.state.IN_PROGRESS = true;
            deferred.resolve(this);

            this.printer.deviceInstall().then(function(response) {
            }).catch(function(error) {
              that.progression = 'FAILED';
              that.state.ABORT = true;
              that.state.IN_PROGRESS = false;
            });
            return deferred.promise
          }

          this.unInstall = () => {
            const that = this;
            const deferred = $q.defer()
            this.progression = 'UNINSTALLING';
            this.state.IN_PROGRESS = true;
            deferred.resolve(this);

            this.printer.deviceUnInstall().then(function(response) {
            }).catch(function(error) {
              that.progression = 'FAILED';
              that.state.ABORT = true;
              that.state.IN_PROGRESS = false;
            });
            return deferred.promise
          }
        }

        (function() {
          segmentPrintesByGoSupport()
        })();

        function segmentPrintesByGoSupport () {
          
          scope.printers.goSupport = angular.copy(scope.printers.all.filter(printer => scope.goVendors.includes(printer.info.vendor)));
          scope.printers.noGoSupport = angular.copy(scope.printers.all.filter(printer => !scope.goVendors.includes(printer.info.vendor)));

          angular.forEach(scope.goVendors, (goVendor) => {
            const printers = scope.printers.goSupport.filter(printer => goVendor.includes(printer.info.vendor));
            if (printers.length > 0) { 
              scope.printers.goVendorPrinters[goVendor] = printers
            }
          })

          angular.forEach(scope.allVendors, (noGoVendor) => {
            const printers = scope.printers.noGoSupport.filter(printer => noGoVendor.includes(printer.info.vendor));
            if (printers.length > 0) {
              scope.printers.noGoVendorPrinters[noGoVendor] = printers
            }
          })

          angular.forEach(scope.printers.goVendorPrinters, (printer) => {
            scope.printers.latestVersion.go[printer[0].info.vendor] = printer[0].onDeviceVersionData.onDeviceVersionMatch.latest
            scope.printers.latestVersion.capture[printer[0].info.vendor] = printer[0].onDeviceVersionData.captureVersionMatch.latest
          })

          angular.forEach(scope.printers.goVendorPrinters, (goVendor) => {
            angular.forEach(goVendor, (printer) => {
              printer.info.problems = definePrinterProblems(printer)
              printer.info.install = setGoSpecifics(printer);
            })
          })

          printersHasProblems();
          scope.printers.goVendorPrinters = sortObj(scope.printers.goVendorPrinters);
          scope.printers.noGoVendorPrinters = sortObj(scope.printers.noGoVendorPrinters);

        }

        function setGoSpecifics (printer) {
            var installer = new DeviceInstall(printer)

            if (printer.info.onDeviceConfig) {
              installer.goConfig = new OnDeviceConfigModel(printer.info.onDeviceConfig)
            }

            if (printer.info.printerCredential) {
              installer.signInProfile = new GoProfileModel(printer.info.printerCredential)
            }
          return installer;
        }

        function definePrinterProblems (printer) {
          let problems = {};

          if (printer.info._embedded.status.state === 'UNAVAILABLE') {
            problems['OFFLINE'] = true
          }

          if (scope.meta.name !== 'Install') {
            if (!printer.info.onDeviceConfig) {
              problems['ONDEVICE_CONFIG_NOT_FOUND'] = true
            }
 
            if (!printer.info.printerCredential) {
              problems['PRINTER_CREDENTIALS_NOT_FOUND'] = true
            }
            if (!printer.info.onDeviceVersionStr) {
              problems['GO_NOT_INSTALLED'] = true
            }
          }

          if (Object.keys(problems).length > 0) {
            problems['number'] = Object.keys(problems).length;
          } else {
            problems = null;
          }
          
          return problems
        }

        function printersHasProblems () {
          scope.printers.hasProblems = scope.printers.goSupport.some((printer) => printer.info.problems)

          switch (scope.meta.name) {
            case 'Install':
              scope.printers.missingInstallData = scope.printers.goSupport.some((printer) => !printer.info.install.signInProfile || !printer.info.install.goConfig)
            break;
            case 'Uninstall':
              scope.printers.missingInstallData = scope.printers.goSupport.some((printer) => !printer.info.install.signInProfile)
            break;
            case 'Update':
              scope.printers.missingInstallData = scope.printers.goSupport.some((printer) => !printer.info.install.signInProfile)
            break;
          } 

        }

        function sortObj(obj) {
          return Object.keys(obj).sort().reduce(function (result, key) {
            result[key] = obj[key];
            return result;
          }, {});
        }

        scope.removePrinter = function (printer, index) {
          const printerID = printer.info._links.self.href;
          scope.printers.goVendorPrinters[printer.info.vendor].splice(index, 1)
          const foundIndex = scope.printers.goSupport.findIndex((printer) => printer.info._links.self.href === printerID);
          scope.printers.goSupport.splice(foundIndex, 1);
          if (scope.printers.goVendorPrinters[printer.info.vendor].length <= 0) {
            delete scope.printers.goVendorPrinters[printer.info.vendor]
          }
          printersHasProblems()
        }

        scope.removeNoGoPrinter = function (printer, index) {
          const printerID = printer.info._links.self.href;
          
          scope.printers.noGoVendorPrinters[printer.info.vendor].splice(index, 1)
          const foundIndex = scope.printers.noGoSupport.findIndex((printer) => printer.info._links.self.href === printerID);
          scope.printers.noGoSupport.splice(foundIndex, 1);

          unselectPrinter(printer)
          if (scope.printers.noGoVendorPrinters[printer.info.vendor].length <= 0) {
            delete scope.printers.noGoVendorPrinters[printer.info.vendor]
          }
        } 

        function unselectPrinter (printer) {
          angular.forEach(scope.printers.all, (printerFromList) => {
            if (printer.info._links.self.href === printerFromList.info._links.self.href) {
              printerFromList.options.isSelected = false;
            }
          })
        }

        scope.udpatePrintersGoSoftware = function () {
          scope.updatingGoSoftware = true;
          scope.resource.tenant.updateGoPrintersSoftware(scope.printers.goSupport).then(function(response) {
            scope.updatingGoSoftware = false;
            scope.callback();
          }).catch(function(error) {
            scope.updatingGoSoftware = false;
          });
        }

        scope.toggleNoGoPrinters = function () {
          scope.showNoGoPrinters = !scope.showNoGoPrinters;
        }

        scope.close = function () {
          scope.callback();
        }

        scope.openSelectDialog = function (type, vendor, printer) {
          scope.vendor = vendor;
          if (printer) {
            scope.editMode = 'SINGLE'
            scope.singlePrinter = printer;
            scope.vendorPrinters = null;
          } else {
            scope.editMode = 'VENDOR'
            scope.vendorPrinters = scope.printers.goVendorPrinters[vendor];
            scope.singlePrinter = null;
          }

          switch (type) {
            case 'SELECT_SIGN_IN_PROFILE':
              scope.selectSignInProfile = true;
              scope.selectGoConfig = false;
            break;
            case 'SELECT_GO_CONFIG':
              scope.selectGoConfig = true;
              scope.selectSignInProfile = false;
            break;
          } 

        }

        scope.closeSelectDialog = function () {
          scope.vendorPrinters = null;
          scope.singlePrinter = null;
          scope.vendor = null;
          scope.selectSignInProfile = false;
          scope.selectGoConfig = false;
        }

        scope.stageInstallationData = function () {
          scope.vendorPrinters = null
          scope.singlePrinter = null
          scope.vendor = null;
          scope.selectSignInProfile = false;
          scope.selectGoConfig = false;
          printersHasProblems();
        }

        scope.clearStagedInstallData = function (vendor) {
          angular.forEach(scope.printers.goVendorPrinters[vendor], (printer)=> {
            printer.info.install = new DeviceInstall(printer);            
          })
          printersHasProblems();
        }

        scope.installGo = function () {
          scope.installInProgress = true;
          let index = 0;
          scope.printers.processed.installed = []
          scope.printers.processed.failed = []
          $interval(() => {
            scope.printers.goSupport[index].info.install.startInstallationSequence().then(function(deviceInstaller) {
              postProcessesPrinters(deviceInstaller)
            }).catch(function(deviceInstaller) {
              postProcessesPrinters(deviceInstaller)
            });
            index += 1;
          }, 200, scope.printers.goSupport.length) 
        }

        scope.updateGo = () => {
          scope.installInProgress = true;
          let index = 0;
          scope.printers.processed.installed = []
          scope.printers.processed.failed = []
          $interval(() => {
            scope.printers.goSupport[index].info.install.update().then(function(deviceInstaller) {
              postProcessesPrinters(deviceInstaller)
            }).catch(function(deviceInstaller) {
              postProcessesPrinters(deviceInstaller)
            });
            index += 1;
          }, 200, scope.printers.goSupport.length) 
        }

        scope.unInstallGo = () => {
          scope.installInProgress = true;
          let index = 0;
          scope.printers.processed.installed = []
          scope.printers.processed.failed = []
          $interval(() => {
            scope.printers.goSupport[index].info.install.unInstall().then(function(deviceInstaller) {
              postProcessesPrinters(deviceInstaller)
            }).catch(function(deviceInstaller) {
              postProcessesPrinters(deviceInstaller)
            });
            index += 1;
          }, 200, scope.printers.goSupport.length) 
        }

        
        function postProcessesPrinters (deviceInstaller) {
          switch (deviceInstaller.progression) {
            case 'INSTALLING':
              scope.printers.processed.installed.push(deviceInstaller)
            break;
            case 'UPDATING':
              scope.printers.processed.installed.push(deviceInstaller)
            break;
            case 'UNINSTALLING':
              scope.printers.processed.installed.push(deviceInstaller)
            break;

            default:
              scope.printers.processed.failed.push(deviceInstaller)
          }

          var failed = scope.printers.processed.failed.length;
          var installed = scope.printers.processed.installed.length;
          if ((failed + installed) === scope.printers.goSupport.length) {
            scope.installInProgress = false;
            scope.installRetry = true;
            scope.installCompleted = false;
          }

          if (installed === scope.printers.goSupport.length) {
            scope.installInProgress = false;
            scope.installRetry = false;
            scope.installCompleted = true;
          }
        }
        

        scope.retryInstallGo = function () {
          scope.installInProgress = true;
          let index = 0;
          var retry = angular.copy(scope.printers.processed.failed);
          scope.printers.processed.failed = [];
          $interval(() => {
            retry[index].startInstallationSequence().then(function(deviceInstaller) {
              postProcessesPrinters(deviceInstaller)
            }).catch(function(deviceInstaller) {
              postProcessesPrinters(deviceInstaller)
            });
            index += 1;
          }, 200, retry.length) 
        }
        

        var UPDATE_PRINTER_IN_EDITMODE_listener = $rootScope.$on('UPDATE_PRINTER_IN_EDITMODE', (name, data) => {
          angular.forEach(scope.printers.goSupport, (printer)=> {
            if (printer.info._links.self.href === data.printer.info._links.self.href) {
              if (printer.info.install.progression === 'INSTALLING' || printer.info.install.progression === 'UPDATING' || printer.info.install.progression === 'UNINSTALLING') {
                printer.info.onDeviceInstallState = data.printer.info.onDeviceInstallState;
                printer.info.install.stopProcess()
              } 
            }
            return printer
          })
        })

        

        ////////////// TOOLTIP STUFF //////////////
        ////////////// TOOLTIP STUFF //////////////
        ////////////// TOOLTIP STUFF //////////////
        ////////////// TOOLTIP STUFF //////////////
        ////////////// TOOLTIP STUFF //////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          var offsetLeft  =  angular.element('.context-content-container')[0].offsetLeft;  
          var offsetTop  =  angular.element('.context-content-container')[0].offsetTop;  
          if (showTip) { 
            position.startX = position.startX - offsetLeft; 
            position.startY = position.startY - offsetTop; 
            switch(tooltipScope) {
              case 'printerGoProblems':
                showPrinterGoProblemsTooltip(position, context);
              break;
              case 'goConfiguration':
                goConfigurationTooltip(position, context)
                break;
            }
          } else {
            scope.clearTooltip();
          }
        }

        function showPrinterGoProblemsTooltip (position, printer) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'Issues',
            type: 'printerGoProblems',
            printer: printer.info,
          }
          scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20},
            contextMenu: true
          }
        }

        function goConfigurationTooltip(position, printer) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'Printer',
            type: 'goConfigurationInstall',
            printer: printer.info,
          }
          scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20},
            contextMenu: true
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }

        scope.$on('$destroy', function() {
          UPDATE_PRINTER_IN_EDITMODE_listener()
        });

      }
    };
  }

  pxPrintersGoActions.$inject = [
    '$timeout', '$filter', 'toastr', '$http', 'GoProfilePaging', 'GoProfileService', '$q', '$interval',
    'GoProfileModel', 'EventServiceEvents', 'OnDeviceConfigModel', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxPrintersGoActions', pxPrintersGoActions);

})();
